// Rapor Tutarlılık Denetimi — /api/v1/projects/:id/report-checks typed wrapper'ları.
// Hata kodları ApiError.code'da gelir (input_changed, report_check_active, report_too_large, no_content,
// check_superseded).
import type {
  FindingStatusPatch,
  ReportCheckDetail,
  ReportCheckEstimate,
  ReportCheckFindingDto,
  ReportCheckSummary,
} from "@mahir/shared";
import { api } from "./client";

const base = (projectId: string): string => `/projects/${projectId}/report-checks`;

export function getReportCheckEstimate(projectId: string): Promise<ReportCheckEstimate> {
  return api<ReportCheckEstimate>(`${base(projectId)}/estimate`);
}

export function startReportCheck(
  projectId: string,
  inputFingerprint: string,
): Promise<{ checkId: string }> {
  return api<{ checkId: string }>(base(projectId), {
    method: "POST",
    body: { inputFingerprint },
  });
}

/** Henüz denetim yoksa sunucu JSON `null` döner. */
export function getCurrentReportCheck(projectId: string): Promise<ReportCheckDetail | null> {
  return api<ReportCheckDetail | null>(`${base(projectId)}/current`);
}

export function listReportChecks(projectId: string): Promise<ReportCheckSummary[]> {
  return api<ReportCheckSummary[]>(base(projectId));
}

export function getReportCheck(projectId: string, checkId: string): Promise<ReportCheckDetail> {
  return api<ReportCheckDetail>(`${base(projectId)}/${checkId}`);
}

export function patchFinding(
  projectId: string,
  checkId: string,
  findingId: string,
  patch: FindingStatusPatch,
): Promise<ReportCheckFindingDto> {
  return api<ReportCheckFindingDto>(`${base(projectId)}/${checkId}/findings/${findingId}`, {
    method: "PATCH",
    body: patch,
  });
}
